import { useCallback, useEffect, useMemo, useState } from 'react';

import { FieldComponentProps } from '@app/components/common/types';
import { MultiSelectField, Txt } from '@app/components/common';


export const openStatusIds = [1, 2, 3, 8, 9];
const statusGroups = [
  { id: -1, name: 'Все' },
  { id: 100, name: 'Все открытые' },
  { id: 200, name: 'Все закрытые' },
];

export const openStatuses = [
  { id: 1, name: 'Создана' },
  { id: 2, name: 'Исправлена' },
  { id: 3, name: 'Отправлена сервисному провайдеру' },
  { id: 8, name: 'Отправляется сервисному провайдеру' },
  { id: 9, name: 'Ошибка при отправке данных' },
];

export const SelectStatusField = ({ value, onChange, statuses }: Pick<FieldComponentProps<EntityBase[]>, 'value' | 'onChange'> & { statuses: EntityBase[] }) => {
  const [statusValue, setStatusValue] = useState<EntityBase[]>([statusGroups[1]]); 

  useEffect(() => {
    if (!value || value.length === 0) {
      setStatusValue([statusGroups[0]]);
      return;
    }
    if (value.length === 1) {
      setStatusValue([value[0]]);
      return;
    }
    if (value.length === openStatusIds.length && value.every((item) => openStatusIds.includes(Number(item.id)))) {
      setStatusValue([statusGroups[1]]);
      return;
    }
    if (value.length === statuses.length - openStatusIds.length && value.every((item) => !openStatusIds.includes(Number(item.id)))) {
      setStatusValue([statusGroups[2]]);
      return;
    }
    setStatusValue(value);
    
  }, [statuses.length, value]);
  
  const options = useMemo(() => {
    return [
      statusGroups[0],
      statusGroups[1],
      ...statuses.filter((item) => {
        return openStatusIds.includes(Number(item.id));
      }).sort((a, b) => Number(a.id) - Number(b.id)),
      statusGroups[2],
      ...statuses.filter((item) => {
        return !openStatusIds.includes(Number(item.id));
      }).sort((a, b) => Number(a.id) - Number(b.id)),
    ];
  }, [statuses]);
  
  const onChangeValue = useCallback((_value: EntityBase) => {
    if (_value.id === -1) {
      onChange(undefined);
      return;
    }
    if (_value.id === 100) {
      onChange(openStatuses);
      return;
    }
    if (_value.id === 200) {
      onChange([...statuses.filter((item) => !openStatusIds.includes(Number(item.id)))]);
      return;
    }
    if (statusValue.length === 1 && (statusValue[0].id === -1 || statusValue[0].id === 100 || statusValue[0].id === 200)) { 
      onChange([_value]);
      return;
    }
    if (statusValue.length > 1 && statusValue.some((item) => item.id === _value.id)) {
      onChange(statusValue.filter((item) => item.id !== _value.id));
      return;
    }
    if (statusValue.length === 1 && statusValue[0].id === _value.id) {
      return;
    }
    onChange([...statusValue, _value]);
  }, [onChange, statuses, statusValue]);
  
  return <MultiSelectField
    id='status'
    name='status'
    label='Статус'
    value={statusValue}
    onClickItem={onChangeValue}
    options={options}
    clearable={false}
    customBodyRender={(value) => {
      if (value.id === -1) {
        return <Txt ml={0} color='brand.500'>Все</Txt>;
      }
      if (value.id === 100) {
        return <Txt ml={2} color='green.500'>Все открытые</Txt>;
      }
      if (value.id === 200) {
        return <Txt ml={2} color='red.500'>Все закрытые</Txt>;
      }
      return <Txt ml={4} color='gray.500'>{value?.name}</Txt>;
    }}
  />;
};